<script>

  import { checkbox } from 'vue-strap';

  export default {
    components: { checkbox },
    data() {
      return {
        filtros: {
          comProvisao: "1",
          comContaPagar: "1",
        },
      }
    },
    watch: {
      'filtros.comProvisao': 'recarregarRelatorio',
      'filtros.comContaPagar': 'recarregarRelatorio',
    },
    props: ['relatorio', 'projeto'],
    methods: {
      recarregarRelatorio() {
        this.relatorio = this.relatorio;
      },
      totalParcialProvisao(itens) {
        return itens.reduce((totalItem, item) => totalItem + item.valorProvisao, 0)
      },
      totalParcialAPagar(itens) {
        return itens.reduce((totalItem, item) => totalItem + item.valorPagar, 0)
      },
      totalParcialAReceber(itens) {
        return itens.reduce((totalItem, item) => totalItem + item.valorReceber, 0)
      },
      totalParcialLancado(itens) {
        return itens.reduce((totalItem, item) => totalItem + item.valorLancado + item.valorGastoRubrica, 0)
      },
      totalParcialRepassado(itens) {
        return itens.reduce((totalItem, item) => totalItem + item.valorSubrubrica, 0)
      },
      totalParcialValorTotal(itens) {
        return itens.reduce((totalItem, item) => totalItem + item.valorTotalSubrubrica, 0)
      },
      totalParcial(itens, isTotal, isTotalRubrica = false) {
        if (this.projeto.utilizarDefinicaoSubrubrica) {
          return itens.reduce((total, item) => total + this.saldoParcial(item, isTotal), 0);
        } else {
          if (isTotalRubrica) {
            if (itens[0].participaSaldo == false)
              return 0;
          }

          var provisao = 0;
          var pagar = 0;

          if (this.filtros.comProvisao == "1")
            provisao = this.totalParcialProvisao(itens);

          if (this.filtros.comContaPagar == "1")
            pagar = this.totalParcialAPagar(itens);

          return itens[0].valorRubrica - provisao + this.totalParcialLancado(itens) - pagar;
        }
      },
      formatarNumero(valor) {
        return this.$options.filters.formatarNumero(valor);
      },
      saldoParcial(item, isTotal) {
        if (isTotal) {
          if (item.participaSaldo == false)
            return 0;
        }

        var provisao = 0;
        var pagar = 0;

        if (this.filtros.comProvisao == "1")
          provisao = item.valorProvisao;

        if (this.filtros.comContaPagar == "1")
          pagar = item.valorPagar;

        return (item.participaSaldo ? item.valorSubrubrica : 0) - provisao + item.valorLancado - pagar;
      },
    },
    computed: {
      totalProvisao() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((total, chave) => {
            return total + this.totalParcialProvisao(metaEtapa[chave]);
          }, 0);
        });

        return total;
      },
      totalAPagar() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((total, chave) => {
            return total + this.totalParcialAPagar(metaEtapa[chave]);
          }, 0);
        });

        return total;
      },
      totalAReceber() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((total, chave) => {
            return total + this.totalParcialAReceber(metaEtapa[chave]);
          }, 0);
        });

        return total;
      },
      totalLancado() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((total, chave) => {
            return total + this.totalParcialLancado(metaEtapa[chave]);
          }, 0);
        });

        return total;
      },
      totalRepassado() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((total, chave) => {
            return total + this.totalParcialRepassado(metaEtapa[chave]);
          }, 0);
        });

        return total;
      },
      totalValorTotal() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((total, chave) => {
            return total + this.totalParcialValorTotal(metaEtapa[chave]);
          }, 0);
        });

        return total;
      },
      total() {
        let total = 0;

        this.relatorio.forEach(metaEtapa => {
          total += Object.keys(metaEtapa).reduce((total, chave) => {
            return total + this.totalParcial(metaEtapa[chave], true, true);
          }, 0);
        });

        return total;
      },
    }
  }
</script>

<template>
  <div>

    <div class="table-responsive">
      <!--<table class="table table-condensed no-margins">
        <thead>
          <tr>
            <th>Projeto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="no-border-right">{{ projeto.nomeProjeto}}</td>
          </tr>
          <tr>
            <td>Saldo calculado com...</td>
          </tr>
          <tr>
            <td class="no-border-right">
              <checkbox v-model="filtros.comProvisao" value="1" type="success" true-value="1" false-value="0">
                Valores provisionados pagar
              </checkbox>
              <checkbox v-model="filtros.comContaPagar" value="1" type="success" true-value="1" false-value="0">
                Valores a pagar
              </checkbox>
            </td>
          </tr>
        </tbody>
      </table>-->

      <table class="table relatorio table-bordered table-striped no-margin-bottom" v-for="(metaEtapa, indice) in relatorio">
        <thead>
          <tr v-if="projeto.utilizarMetaEtapaProjeto">
            <th colspan="8"><b>{{ metaEtapa[Object.keys(metaEtapa)[0]][0].metaEtapa }}</b></th>
          </tr>
          <tr>
            <th>Rubrica</th>
            <th class="text-right">Valor Total</th>
            <th class="text-right">Repassado</th>
            <th class="text-right">Provisão pagar</th>
            <th class="text-right">A pagar</th>
            <th class="text-right">A receber</th>
            <th class="text-right">Lançado(+/-)</th>
            <th class="text-right">Saldo(=)</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="itens in metaEtapa">
            <tr>
              <td>{{ itens[0].nomeRubrica }}</td>
              <td class="text-right">{{ projeto.utilizarDefinicaoSubrubrica ? '' : formatarNumero(itens[0].valorTotalRubrica) }}</td>
              <td class="text-right">{{ projeto.utilizarDefinicaoSubrubrica ? '' : formatarNumero(itens[0].valorRubrica) }}</td>
              <td class="text-right"></td>
              <td class="text-right"></td>
              <td class="text-right"></td>
              <td class="text-right"></td>
              <td class="text-right"></td>
            </tr>
            <tr v-for="item in itens">
              <td class="tab-1">{{ item.nomeSubrubrica }}</td>
              <td class="text-right">{{ projeto.utilizarDefinicaoSubrubrica ? formatarNumero(item.valorTotalSubrubrica) : '' }}</td>
              <td class="text-right">{{ projeto.utilizarDefinicaoSubrubrica ? formatarNumero(item.valorSubrubrica) : '' }}</td>
              <td class="text-right">{{ formatarNumero(item.valorProvisao) }}</td>
              <td class="text-right">{{ formatarNumero(item.valorPagar) }}</td>
              <td class="text-right">{{ formatarNumero(item.valorReceber) }}</td>
              <td class="text-right">{{ formatarNumero(item.valorLancado + item.valorGastoRubrica) }}</td>
              <td class="text-right">{{ projeto.utilizarDefinicaoSubrubrica ? formatarNumero(saldoParcial(item, false)) : '' }}</td>
            </tr>
            <tr>
              <td class="font-bold tab-1">TOTAL</td>
              <td class="text-right font-bold">{{ projeto.utilizarDefinicaoSubrubrica ? formatarNumero(totalParcialValorTotal(itens)) : '' }}</td>
              <td class="text-right font-bold">{{ projeto.utilizarDefinicaoSubrubrica ? formatarNumero(totalParcialRepassado(itens)) : '' }}</td>
              <td class="text-right font-bold">{{ formatarNumero(totalParcialProvisao(itens)) }}</td>
              <td class="text-right font-bold">{{ formatarNumero(totalParcialAPagar(itens)) }}</td>
              <td class="text-right font-bold">{{ formatarNumero(totalParcialAReceber(itens)) }}</td>
              <td class="text-right font-bold">{{ formatarNumero(totalParcialLancado(itens)) }}</td>
              <td class="text-right font-bold">{{ formatarNumero(totalParcial(itens, true)) }}</td>
            </tr>
          </template>
          <tr>
            <td class="text-right"><br/></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
            <td class="text-right"></td>
          </tr>
          <tr v-if="Object.keys(relatorio).length - 1 === indice">
            <td class="font-bold">Total para o projeto</td>
            <td class="text-right font-bold">{{ projeto.utilizarDefinicaoSubrubrica ? formatarNumero(totalValorTotal) : '' }}</td>
            <td class="text-right font-bold">{{ projeto.utilizarDefinicaoSubrubrica ? formatarNumero(totalRepassado) : '' }}</td>
            <td class="text-right font-bold">{{ formatarNumero(totalProvisao) }}</td>
            <td class="text-right font-bold">{{ formatarNumero(totalAPagar) }}</td>
            <td class="text-right font-bold">{{ formatarNumero(totalAReceber) }}</td>
            <td class="text-right font-bold">{{ formatarNumero(totalLancado) }}</td>
            <td class="text-right font-bold">{{ formatarNumero(total) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/RelatorioLancamentosRubricaSintetico.vue